<div class="mau-wrapper">

  <!-- ══ HEADER FIJO ══ -->
  <div class="mau-header" [ngClass]="'greendAnalityco' || 'primary'">
    <div class="mau-header__content">
      <i class="mau-header__icon ti ti-files" aria-hidden="true"></i>
      <span class="mau-header__title">{{ data?.title || 'ARCHIVOS Y COMENTARIOS' }}</span>
    </div>
  </div>

  <!-- ══ PROCESSING STATE ══ -->
  <div *ngIf="isProcessing" class="mau-processing">
    <div class="mau-processing__inner">
      <span class="mau-processing__label">PROCESANDO</span>
      <mat-progress-bar mode="query" [value]="20"></mat-progress-bar>
    </div>
  </div>

  <!-- ══ CONTENIDO SCROLLABLE ══ -->
  <div *ngIf="!isProcessing" class="mau-content">

    <div class="mau-type-row"
         *ngIf="module === 'Personal' || module === 'Termination' || module === 'GenerateWithdrawals'">
      <label class="mau-field-label">TIPO DE ACTUALIZACIÓN</label>
      <app-select-search *ngIf="module === 'Personal'"
                         class="mau-select"
                         [_dataSource]="typesUpdate" [dataShow]="'Name'" [dataValue]="'Id'"
                         [siteCtrl]="controlSearchTypUpdate" [inputType]="'text'"
                         (onSelectionChange)="changeTypeUpdate($event)">
      </app-select-search>
      <app-select-search *ngIf="module === 'Termination' || module === 'GenerateWithdrawals'"
                         class="mau-select"
                         [_dataSource]="typesUpdateTermination" [dataShow]="'Name'" [dataValue]="'Id'"
                         [siteCtrl]="controlSearchTypUpdateTermination" [inputType]="'text'"
                         (onSelectionChange)="changeTypeUpdateTermination($event)">
      </app-select-search>
    </div>

    <!-- ══ MÓDULO: Personal / Employer ══ -->
    <div class="mau-module"
         *ngIf="(module === 'Personal' || module === 'Employer') && typeShowDialog === 1 && exitPermissionCompany('massuploadpersonal.personalcreation')">

      <div class="mau-stepper">
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot mau-stepper__dot--done"><mat-icon>download</mat-icon></div>
          <span class="mau-stepper__label">Descargar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="files.length > 0"></div>
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--done]="files.length > 0"
               [class.mau-stepper__dot--active]="files.length === 0">
            <mat-icon *ngIf="files.length > 0">check</mat-icon>
            <span *ngIf="files.length === 0">2</span>
          </div>
          <span class="mau-stepper__label">Cargar</span>
        </div>
      </div>

      <div class="mau-info-card">
        <div class="mau-info-card__header">
          <mat-icon class="mau-info-card__icon">info_outline</mat-icon>
          <span class="mau-info-card__title">Instrucciones</span>
        </div>
        <ol class="mau-info-card__steps">
          <li>Descargue el archivo con el formato</li>
          <li>Diligencie los datos en el archivo descargado</li>
          <li>Cargue el archivo diligenciado</li>
        </ol>
        <div class="mau-info-card__note">
          <mat-icon>warning_amber</mat-icon>
          Máximo 100 registros por carga
        </div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Formato para descargar</div>
        <div class="mau-download-card">
          <div class="mau-download-card__info">
            <mat-icon class="mau-download-card__icon">description</mat-icon>
            <span class="mau-download-card__text">Plantilla de actualización masiva</span>
          </div>
          <a [href]="urlFormat" download class="mau-btn mau-btn--download">
            <mat-icon>file_download</mat-icon>Descargar
          </a>
        </div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Cargar formato diligenciado</div>
        <div *ngIf="module === 'Personal'">
          <ngx-dropzone *ngIf="files.length === 0" (change)="onSelect($event)" class="mau-dropzone" [multiple]="false">
            <ngx-dropzone-label class="mau-dropzone__label">
              <mat-icon class="mau-dropzone__icon">cloud_upload</mat-icon>
              <span class="mau-dropzone__text">Clic aquí o arrastra y suelta el archivo</span>
              <span class="mau-dropzone__hint">XLSX, CSV, PDF</span>
            </ngx-dropzone-label>
          </ngx-dropzone>
        </div>
        <div *ngIf="module === 'Employer'">
          <ngx-dropzone *ngIf="files.length === 0" (change)="onSelect($event)" class="mau-dropzone" [multiple]="false">
            <ngx-dropzone-label class="mau-dropzone__label">
              <mat-icon class="mau-dropzone__icon">cloud_upload</mat-icon>
              <span class="mau-dropzone__text">Clic aquí o arrastra y suelta el archivo</span>
              <span class="mau-dropzone__hint">XLSX, CSV, PDF</span>
            </ngx-dropzone-label>
          </ngx-dropzone>
        </div>
        <div *ngIf="files.length > 0" class="mau-file-chip">
          <mat-icon class="mau-file-chip__icon">insert_drive_file</mat-icon>
          <span class="mau-file-chip__name">{{ files[0]?.name }}</span>
          <button mat-icon-button class="mau-file-chip__remove" (click)="removeFile()"><mat-icon>close</mat-icon></button>
        </div>
        <div *ngIf="module === 'Personal'" class="mau-comment-wrap">
          <label class="mau-field-label">Comentario</label>
          <mat-form-field class="mau-comment-field" appearance="outline">
            <textarea matInput [(ngModel)]="commentary" maxlength="280" rows="3" placeholder="Escriba un comentario..."></textarea>
            <mat-hint align="end">{{ commentary?.length || 0 }}/280</mat-hint>
          </mat-form-field>
        </div>
        <div *ngIf="module === 'Employer'" class="mau-comment-wrap">
          <label class="mau-field-label">Comentario</label>
          <mat-form-field class="mau-comment-field" appearance="outline">
            <textarea matInput [(ngModel)]="commentary" maxlength="280" rows="3" placeholder="Escriba un comentario..."></textarea>
            <mat-hint align="end">{{ commentary?.length || 0 }}/280</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="mau-empty-state" *ngIf="storiesFiles.length === 0">
        <mat-icon class="mau-empty-state__icon">folder_open</mat-icon>
        <span class="mau-empty-state__text">0 documentos guardados</span>
      </div>
      <ng-container *ngIf="storiesFiles.length > 0">
        <div class="mau-history-header"><mat-icon>history</mat-icon><span>Actualizaciones</span></div>
        <div class="mau-history-list">
          <div class="mau-history-card" *ngFor="let story of storiesFiles">
            <div class="mau-history-card__row">
              <span class="mau-history-card__label">Actualizado</span>
              <span class="mau-history-card__value">{{ story.StateDescription }} {{ getDateFormatR(story?.Date) || 'Fecha no reportada' }} {{ getDateFormatRMinutes(story?.Date) || '' }}</span>
              <mat-icon class="mau-history-card__user" matTooltipPosition="above" [matTooltip]="'Usuario: ' + (story?.UserName !== undefined ? story?.UserName : 'No reportado')">account_circle</mat-icon>
            </div>
            <div class="mau-history-card__row" *ngIf="story?.Key !== '' && story?.Key !== null">
              <span class="mau-history-card__label">Documento</span>
              <span class="mau-history-card__filename" matTooltipPosition="above" [matTooltip]="stateCurrent.Name">{{ story.Name }}</span>
              <mat-icon class="mau-history-card__view" (click)="openImgVideoUrl(story.Key)" matTooltip="Ver documento">visibility</mat-icon>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- ══ MÓDULO: Planillas ══ -->
    <div class="mau-module" *ngIf="module === 'Planillas'">

      <div class="mau-stepper">
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot mau-stepper__dot--done"><mat-icon>download</mat-icon></div>
          <span class="mau-stepper__label">Descargar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="files.length > 0"></div>
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--done]="files.length > 0"
               [class.mau-stepper__dot--active]="files.length === 0">
            <mat-icon *ngIf="files.length > 0">check</mat-icon>
            <span *ngIf="files.length === 0">2</span>
          </div>
          <span class="mau-stepper__label">Cargar</span>
        </div>
      </div>

      <div class="mau-info-card">
        <div class="mau-info-card__header">
          <mat-icon class="mau-info-card__icon">info_outline</mat-icon>
          <span class="mau-info-card__title">Instrucciones</span>
        </div>
        <ol class="mau-info-card__steps">
          <li>Descargue el archivo con el formato</li>
          <li>Diligencie los datos en el archivo descargado</li>
          <li>Cargue el archivo diligenciado</li>
        </ol>
        <div class="mau-info-card__note">
          <mat-icon>warning_amber</mat-icon>
          Máximo 500 registros por carga
        </div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Formato para descargar</div>
        <div class="mau-download-card">
          <div class="mau-download-card__info">
            <mat-icon class="mau-download-card__icon">description</mat-icon>
            <span class="mau-download-card__text">Plantilla de planillas</span>
          </div>
          <a [href]="urlFormat" download class="mau-btn mau-btn--download">
            <mat-icon>file_download</mat-icon>Descargar
          </a>
        </div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Cargar formato diligenciado</div>
        <ngx-dropzone *ngIf="files.length === 0" (change)="onSelect($event)" class="mau-dropzone" [multiple]="false">
          <ngx-dropzone-label class="mau-dropzone__label">
            <mat-icon class="mau-dropzone__icon">cloud_upload</mat-icon>
            <span class="mau-dropzone__text">Clic aquí o arrastra y suelta el archivo</span>
            <span class="mau-dropzone__hint">XLSX, CSV, PDF</span>
          </ngx-dropzone-label>
        </ngx-dropzone>
        <div *ngIf="files.length > 0" class="mau-file-chip">
          <mat-icon class="mau-file-chip__icon">insert_drive_file</mat-icon>
          <span class="mau-file-chip__name">{{ files[0]?.name }}</span>
          <button mat-icon-button class="mau-file-chip__remove" (click)="removeFile()"><mat-icon>close</mat-icon></button>
        </div>
        <div class="mau-comment-wrap">
          <label class="mau-field-label">Comentario</label>
          <mat-form-field class="mau-comment-field" appearance="outline">
            <textarea matInput [(ngModel)]="commentary" maxlength="280" rows="3" placeholder="Escriba un comentario..."></textarea>
            <mat-hint align="end">{{ commentary?.length || 0 }}/280</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="mau-empty-state" *ngIf="storiesFiles.length === 0">
        <mat-icon class="mau-empty-state__icon">folder_open</mat-icon>
        <span class="mau-empty-state__text">0 documentos guardados</span>
      </div>
      <ng-container *ngIf="storiesFiles.length > 0">
        <div class="mau-history-header"><mat-icon>history</mat-icon><span>Actualizaciones</span></div>
        <div class="mau-history-list">
          <div class="mau-history-card" *ngFor="let story of storiesFiles">
            <div class="mau-history-card__row">
              <span class="mau-history-card__label">Actualizado</span>
              <span class="mau-history-card__value">{{ story.StateDescription }} {{ getDateFormatR(story?.Date) || 'Fecha no reportada' }} {{ getDateFormatRMinutes(story?.Date) || '' }}</span>
              <mat-icon class="mau-history-card__user" matTooltipPosition="above" [matTooltip]="'Usuario: ' + (story?.UserName !== undefined ? story?.UserName : 'No reportado')">account_circle</mat-icon>
            </div>
            <div class="mau-history-card__row" *ngIf="story?.Key !== '' && story?.Key !== null">
              <span class="mau-history-card__label">Documento</span>
              <span class="mau-history-card__filename" matTooltipPosition="above" [matTooltip]="stateCurrent.Name">{{ story.Name }}</span>
              <mat-icon class="mau-history-card__view" (click)="openImgVideoUrl(story.Key)" matTooltip="Ver documento">visibility</mat-icon>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- ══ MÓDULO: DOCREQ ══ -->
    <div class="mau-module"
         *ngIf="typeShowDialog === 2 && exitPermissionCompany('massuploadpersonal.updaterequirement')">

      <div class="mau-stepper">
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot mau-stepper__dot--done"><mat-icon>download</mat-icon></div>
          <span class="mau-stepper__label">Descargar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="showFormatLoad || showDocumentLoad"></div>
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--done]="showDocumentLoad"
               [class.mau-stepper__dot--active]="!showFormatLoad && !showDocumentLoad"
               [class.mau-stepper__dot--idle]="showFormatLoad && !showDocumentLoad">
            <mat-icon *ngIf="showDocumentLoad">check</mat-icon>
            <span *ngIf="!showDocumentLoad">2</span>
          </div>
          <span class="mau-stepper__label">Seleccionar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="filesLoadDocument.length > 0"></div>
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--done]="filesLoadDocument.length > 0"
               [class.mau-stepper__dot--active]="showDocumentLoad && filesLoadDocument.length === 0"
               [class.mau-stepper__dot--idle]="!showDocumentLoad">
            <mat-icon *ngIf="filesLoadDocument.length > 0">check</mat-icon>
            <span *ngIf="filesLoadDocument.length === 0">3</span>
          </div>
          <span class="mau-stepper__label">Cargar</span>
        </div>
      </div>

      <div class="mau-info-card">
        <div class="mau-info-card__header">
          <mat-icon class="mau-info-card__icon">info_outline</mat-icon>
          <span class="mau-info-card__title">Instrucciones</span>
        </div>
        <ol class="mau-info-card__steps">
          <li>Descargue el archivo con el formato</li>
          <li>Diligencie los datos en el archivo descargado</li>
          <li>Cargue el archivo diligenciado</li>
          <li><strong>Cargue el documento a copiar en todos los requisitos</strong></li>
        </ol>
        <div class="mau-info-card__note"><mat-icon>warning_amber</mat-icon>Máximo 500 registros por carga</div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Formato para descargar</div>
        <div class="mau-download-card">
          <div class="mau-download-card__info">
            <mat-icon class="mau-download-card__icon">description</mat-icon>
            <span class="mau-download-card__text">Plantilla de requisitos</span>
          </div>
          <a [href]="urlFormat" download class="mau-btn mau-btn--download"><mat-icon>file_download</mat-icon>Descargar</a>
        </div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Seleccionar requisito</div>
        <div class="mau-select-wrap">
          <app-select-search-custom class="selected"
                                    [_dataSource]="requirementToSelect" [dataShow]="'Name'" [dataValue]="'Id'"
                                    [siteCtrl]="controlSearchRequirementSelect" [inputType]="'text'"
                                    (onSelectionChange)="changeRequirementSelect($event)">
          </app-select-search-custom>
        </div>
      </div>

      <div class="mau-section" *ngIf="showEmployerSelect">
        <div class="mau-section__label">Seleccionar empleador</div>
        <div class="mau-select-wrap">
          <app-select-search [_dataSource]="employerToSelect" [dataShow]="'Name'" [dataValue]="'Id'"
                             [siteCtrl]="controlSearchEmployer" [inputType]="'text'"
                             (onSelectionChange)="changeEmployerSelect($event)">
          </app-select-search>
        </div>
      </div>

      <div class="mau-section" *ngIf="showFormatLoad">
        <div class="mau-section__label">Cargar formato diligenciado</div>
        <ngx-dropzone *ngIf="filesFormatLoad.length === 0" (change)="onSelectFormatLoad($event)" class="mau-dropzone" [multiple]="false">
          <ngx-dropzone-label class="mau-dropzone__label">
            <mat-icon class="mau-dropzone__icon">cloud_upload</mat-icon>
            <span class="mau-dropzone__text">Clic aquí o arrastra y suelta el archivo</span>
            <span class="mau-dropzone__hint">XLSX, CSV, PDF</span>
          </ngx-dropzone-label>
        </ngx-dropzone>
        <div *ngIf="filesFormatLoad.length > 0" class="mau-file-chip">
          <mat-icon class="mau-file-chip__icon">insert_drive_file</mat-icon>
          <span class="mau-file-chip__name">{{ filesFormatLoad[0]?.name }}</span>
          <button mat-icon-button class="mau-file-chip__remove" (click)="removeFileFormatLoad()"><mat-icon>close</mat-icon></button>
        </div>
      </div>

      <div class="mau-section" *ngIf="showDocumentLoad">
        <div class="mau-section__label">Cargar documento</div>
        <ngx-dropzone *ngIf="filesLoadDocument.length === 0" (change)="onSelectLoadDocument($event)" class="mau-dropzone" [multiple]="false">
          <ngx-dropzone-label class="mau-dropzone__label">
            <mat-icon class="mau-dropzone__icon">cloud_upload</mat-icon>
            <span class="mau-dropzone__text">Clic aquí o arrastra y suelta el archivo</span>
            <span class="mau-dropzone__hint">XLSX, CSV, PDF</span>
          </ngx-dropzone-label>
        </ngx-dropzone>
        <div *ngIf="filesLoadDocument.length > 0" class="mau-file-chip">
          <mat-icon class="mau-file-chip__icon">insert_drive_file</mat-icon>
          <span class="mau-file-chip__name">{{ filesLoadDocument[0]?.name }}</span>
          <button mat-icon-button class="mau-file-chip__remove" (click)="removeFileLoadDocument()"><mat-icon>close</mat-icon></button>
        </div>
        <div *ngIf="module === 'Personal'" class="mau-comment-wrap">
          <label class="mau-field-label">Comentario</label>
          <mat-form-field class="mau-comment-field" appearance="outline">
            <textarea matInput [(ngModel)]="commentaryDocReq" maxlength="280" rows="3" placeholder="Escriba un comentario..."></textarea>
            <mat-hint align="end">{{ commentaryDocReq?.length || 0 }}/280</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="mau-empty-state" *ngIf="storiesFilesDoc?.length === 0 || storiesFilesDoc === undefined">
        <mat-icon class="mau-empty-state__icon">folder_open</mat-icon>
        <span class="mau-empty-state__text">0 documentos guardados</span>
      </div>
      <ng-container *ngIf="storiesFilesDoc?.length > 0">
        <div class="mau-history-header"><mat-icon>history</mat-icon><span>Actualizaciones</span></div>
        <div class="mau-history-list">
          <div class="mau-history-card" *ngFor="let story of storiesFilesDoc">
            <div class="mau-history-card__row">
              <span class="mau-history-card__label">Actualizado</span>
              <span class="mau-history-card__value">{{ story.StateDescription }} {{ getDateFormatR(story?.Date) || 'Fecha no reportada' }} {{ getDateFormatRMinutes(story?.Date) || '' }}</span>
              <mat-icon class="mau-history-card__user" matTooltipPosition="above" [matTooltip]="'Usuario: ' + (story?.UserName !== undefined ? story?.UserName : 'No reportado')">account_circle</mat-icon>
            </div>
            <div class="mau-history-card__row" *ngIf="story?.Key !== '' && story?.Key !== null">
              <span class="mau-history-card__label">Documento</span>
              <span class="mau-history-card__filename" matTooltipPosition="above" [matTooltip]="stateCurrentDocReq.docName">{{ story.docName }}</span>
              <mat-icon class="mau-history-card__view" (click)="openImgVideoUrl(story.docPath)" matTooltip="Ver documento">visibility</mat-icon>
            </div>
            <div class="mau-history-card__row" *ngIf="story?.Comments !== '' && story?.Comments !== null">
              <span class="mau-history-card__label">Comentario</span>
              <span class="mau-history-card__comment">{{ story.Comments }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- ══ MÓDULO: Fecha de requisito ══ -->
    <div class="mau-module"
         *ngIf="typeShowDialog === 3 && exitPermissionCompany('massuploadpersonal.updaterequirementdate')">

      <div class="mau-stepper">
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot mau-stepper__dot--done"><mat-icon>download</mat-icon></div>
          <span class="mau-stepper__label">Descargar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="showDateReqFormatLoad"></div>
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--done]="showDateReqFormatLoad && filesDateReq.length > 0"
               [class.mau-stepper__dot--active]="!showDateReqFormatLoad"
               [class.mau-stepper__dot--idle]="showDateReqFormatLoad && filesDateReq.length === 0">
            <mat-icon *ngIf="showDateReqFormatLoad && filesDateReq.length > 0">check</mat-icon>
            <span *ngIf="!(showDateReqFormatLoad && filesDateReq.length > 0)">2</span>
          </div>
          <span class="mau-stepper__label">Seleccionar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="filesDateReq.length > 0"></div>
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--done]="filesDateReq.length > 0"
               [class.mau-stepper__dot--active]="showDateReqFormatLoad && filesDateReq.length === 0"
               [class.mau-stepper__dot--idle]="!showDateReqFormatLoad">
            <mat-icon *ngIf="filesDateReq.length > 0">check</mat-icon>
            <span *ngIf="filesDateReq.length === 0">3</span>
          </div>
          <span class="mau-stepper__label">Cargar</span>
        </div>
      </div>

      <div class="mau-info-card">
        <div class="mau-info-card__header">
          <mat-icon class="mau-info-card__icon">info_outline</mat-icon>
          <span class="mau-info-card__title">Instrucciones</span>
        </div>
        <ol class="mau-info-card__steps">
          <li>Descargue el archivo con el formato</li>
          <li>Diligencie los datos en el archivo descargado</li>
          <li>Cargue el archivo diligenciado</li>
        </ol>
        <div class="mau-info-card__note"><mat-icon>warning_amber</mat-icon>Máximo 500 registros por carga</div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Formato para descargar</div>
        <div class="mau-download-card">
          <div class="mau-download-card__info">
            <mat-icon class="mau-download-card__icon">description</mat-icon>
            <span class="mau-download-card__text">Plantilla de fecha de requisito</span>
          </div>
          <a [href]="urlFormat" download class="mau-btn mau-btn--download"><mat-icon>file_download</mat-icon>Descargar</a>
        </div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Seleccionar requisito</div>
        <div class="mau-select-wrap">
          <app-select-search-custom [_dataSource]="DateReqToSelect" [dataShow]="'Name'" [dataValue]="'Id'"
                                    [siteCtrl]="controlSearchDateReq" [inputType]="'text'"
                                    (onSelectionChange)="changeDateReqSelect($event)">
          </app-select-search-custom>
        </div>
      </div>

      <div class="mau-section" *ngIf="showDateReqFormatLoad">
        <div class="mau-section__label">Cargar formato diligenciado</div>
        <ngx-dropzone *ngIf="filesDateReq.length === 0" (change)="onSelectDateReq($event)" class="mau-dropzone" [multiple]="false">
          <ngx-dropzone-label class="mau-dropzone__label">
            <mat-icon class="mau-dropzone__icon">cloud_upload</mat-icon>
            <span class="mau-dropzone__text">Clic aquí o arrastra y suelta el archivo</span>
            <span class="mau-dropzone__hint">XLSX, CSV, PDF</span>
          </ngx-dropzone-label>
        </ngx-dropzone>
        <div *ngIf="filesDateReq.length > 0" class="mau-file-chip">
          <mat-icon class="mau-file-chip__icon">insert_drive_file</mat-icon>
          <span class="mau-file-chip__name">{{ filesDateReq[0]?.name }}</span>
          <button mat-icon-button class="mau-file-chip__remove" (click)="removeFileDateReq()"><mat-icon>close</mat-icon></button>
        </div>
        <div *ngIf="module === 'Personal'" class="mau-comment-wrap">
          <label class="mau-field-label">Comentario</label>
          <mat-form-field class="mau-comment-field" appearance="outline">
            <textarea matInput [(ngModel)]="commentaryDateReq" maxlength="280" rows="3" placeholder="Escriba un comentario..."></textarea>
            <mat-hint align="end">{{ commentaryDateReq?.length || 0 }}/280</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="mau-empty-state" *ngIf="storiesFilesDateReq?.length === 0 || storiesFilesDateReq === undefined">
        <mat-icon class="mau-empty-state__icon">folder_open</mat-icon>
        <span class="mau-empty-state__text">0 documentos guardados</span>
      </div>
      <ng-container *ngIf="storiesFilesDateReq?.length > 0">
        <div class="mau-history-header"><mat-icon>history</mat-icon><span>Actualizaciones</span></div>
        <div class="mau-history-list">
          <div class="mau-history-card" *ngFor="let story of storiesFilesDateReq">
            <div class="mau-history-card__row">
              <span class="mau-history-card__label">Actualizado</span>
              <span class="mau-history-card__value">{{ story.StateDescription }} {{ getDateFormatR(story?.Date) || 'Fecha no reportada' }} {{ getDateFormatRMinutes(story?.Date) || '' }}</span>
              <mat-icon class="mau-history-card__user" matTooltipPosition="above" [matTooltip]="'Usuario: ' + (story?.UserName !== undefined ? story?.UserName : 'No reportado')">account_circle</mat-icon>
            </div>
            <div class="mau-history-card__row" *ngIf="story?.Key !== '' && story?.Key !== null">
              <span class="mau-history-card__label">Documento</span>
              <span class="mau-history-card__filename" matTooltipPosition="above" [matTooltip]="stateCurrentDateReq.docName">{{ story.docName }}</span>
              <mat-icon class="mau-history-card__view" (click)="openImgVideoUrl(story.docPath)" matTooltip="Ver documento">visibility</mat-icon>
            </div>
            <div class="mau-history-card__row" *ngIf="story?.Comments !== '' && story?.Comments !== null">
              <span class="mau-history-card__label">Comentario</span>
              <span class="mau-history-card__comment">{{ story.Comments }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- ══ MÓDULO: Termination ══ -->
    <div class="mau-module" *ngIf="module === 'Termination'">

      <div class="mau-stepper">
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot mau-stepper__dot--done"><mat-icon>download</mat-icon></div>
          <span class="mau-stepper__label">Descargar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="filesTermination.length > 0"></div>
        <div class="mau-stepper__step" [class.mau-stepper__step--active]="filesTermination.length === 0">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--done]="filesTermination.length > 0"
               [class.mau-stepper__dot--active]="filesTermination.length === 0">
            <mat-icon *ngIf="filesTermination.length > 0">check</mat-icon>
            <span *ngIf="filesTermination.length === 0">2</span>
          </div>
          <span class="mau-stepper__label">Cargar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="showTerminationSelectFinalState"></div>
        <div class="mau-stepper__step" [class.mau-stepper__step--active]="filesTermination.length > 0">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--active]="filesTermination.length > 0"
               [class.mau-stepper__dot--idle]="filesTermination.length === 0">
            <span>3</span>
          </div>
          <span class="mau-stepper__label">Configurar</span>
        </div>
      </div>

      <div class="mau-info-card">
        <div class="mau-info-card__header">
          <mat-icon class="mau-info-card__icon">info_outline</mat-icon>
          <span class="mau-info-card__title">Instrucciones</span>
        </div>
        <ol class="mau-info-card__steps">
          <li>Descargue el archivo con el formato</li>
          <li>Diligencie los datos en el archivo descargado</li>
          <li>Cargue el archivo diligenciado</li>
        </ol>
        <div class="mau-info-card__note"><mat-icon>warning_amber</mat-icon>Máximo 499 registros por carga</div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Formato para descargar</div>
        <div class="mau-download-card">
          <div class="mau-download-card__info">
            <mat-icon class="mau-download-card__icon">description</mat-icon>
            <span class="mau-download-card__text">Plantilla de actualización masiva</span>
          </div>
          <a [href]="urlFormat" download class="mau-btn mau-btn--download"><mat-icon>file_download</mat-icon>Descargar</a>
        </div>
      </div>

      <div class="mau-section" *ngIf="typeShowDialog === 4">
        <div class="mau-section__label">Seleccionar empleador</div>
        <div class="mau-select-wrap">
          <app-select-search [_dataSource]="TerminationEmployerToSelect" [dataShow]="'Name'" [dataValue]="'Id'"
                             [siteCtrl]="controlSearchTerminationEmployer" [inputType]="'text'"
                             (onSelectionChange)="changeTerminationEmployer($event)">
          </app-select-search>
        </div>
      </div>

      <div class="mau-section" *ngIf="showTerminationFormatLoad">
        <div class="mau-section__label">Cargar formato diligenciado</div>
        <ngx-dropzone *ngIf="filesTermination.length === 0" (change)="onSelectTermination($event)" class="mau-dropzone" [multiple]="false">
          <ngx-dropzone-label class="mau-dropzone__label">
            <mat-icon class="mau-dropzone__icon">cloud_upload</mat-icon>
            <span class="mau-dropzone__text">Clic aquí o arrastra y suelta el archivo</span>
            <span class="mau-dropzone__hint">XLSX, CSV, PDF</span>
          </ngx-dropzone-label>
        </ngx-dropzone>
        <div *ngIf="filesTermination.length > 0" class="mau-file-chip">
          <mat-icon class="mau-file-chip__icon">insert_drive_file</mat-icon>
          <span class="mau-file-chip__name">{{ filesTermination[0]?.name }}</span>
          <button mat-icon-button class="mau-file-chip__remove" (click)="removeFileTermination()"><mat-icon>close</mat-icon></button>
        </div>
        <div class="mau-section" *ngIf="showTerminationSelectFinalState">
          <div class="mau-section__label">Estado final</div>
          <div class="mau-select-wrap">
            <app-select-search-custom [_dataSource]="TerminationToSelect" [dataShow]="'Description'" [dataValue]="'Id'"
                                      [siteCtrl]="controlSearchTermination" [inputType]="'text'"
                                      (onSelectionChange)="changeTerminationSelect($event)">
            </app-select-search-custom>
          </div>
        </div>
        <div class="mau-comment-wrap">
          <label class="mau-field-label">Comentario</label>
          <mat-form-field class="mau-comment-field" appearance="outline">
            <textarea matInput [(ngModel)]="commentaryTermination" maxlength="280" rows="3" placeholder="Escriba un comentario..."></textarea>
            <mat-hint align="end">{{ commentaryTermination?.length || 0 }}/280</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="mau-empty-state" *ngIf="storiesFilesTermination?.length === 0 || storiesFilesTermination === undefined">
        <mat-icon class="mau-empty-state__icon">folder_open</mat-icon>
        <span class="mau-empty-state__text">0 documentos guardados</span>
      </div>
      <ng-container *ngIf="storiesFilesTermination?.length > 0">
        <div class="mau-history-header"><mat-icon>history</mat-icon><span>Actualizaciones</span></div>
        <div class="mau-history-list">
          <div class="mau-history-card" *ngFor="let story of storiesFilesTermination">
            <div class="mau-history-card__row">
              <span class="mau-history-card__label">Actualizado</span>
              <span class="mau-history-card__value">{{ getDateFormatR(story?.Date) || 'Fecha no reportada' }} {{ getDateFormatRMinutes(story?.Date) || '' }}</span>
              <mat-icon class="mau-history-card__user" matTooltipPosition="above" [matTooltip]="'Usuario: ' + (story?.UserName || 'No reportado')">account_circle</mat-icon>
            </div>
            <div class="mau-history-card__row" *ngIf="story?.Key !== '' && story?.Key !== null">
              <span class="mau-history-card__label">Documento</span>
              <span class="mau-history-card__filename" matTooltipPosition="above" [matTooltip]="stateCurrentTermination.Name">{{ story.Name }}</span>
              <mat-icon class="mau-history-card__view" (click)="openImgVideoUrl(story.Key)" matTooltip="Ver documento">visibility</mat-icon>
            </div>
            <div class="mau-history-card__row" *ngIf="story?.Comments !== '' && story?.Comments !== null">
              <span class="mau-history-card__label">Comentario</span>
              <span class="mau-history-card__comment">{{ story.Comments }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- ══ MÓDULO: GenerateWithdrawals ══ -->
    <div class="mau-module" *ngIf="module === 'GenerateWithdrawals'">

      <div class="mau-stepper">
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot mau-stepper__dot--done"><mat-icon>download</mat-icon></div>
          <span class="mau-stepper__label">Descargar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="filesTerminationGenerate.length > 0"></div>
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--done]="filesTerminationGenerate.length > 0"
               [class.mau-stepper__dot--active]="filesTerminationGenerate.length === 0">
            <mat-icon *ngIf="filesTerminationGenerate.length > 0">check</mat-icon>
            <span *ngIf="filesTerminationGenerate.length === 0">2</span>
          </div>
          <span class="mau-stepper__label">Cargar</span>
        </div>
        <div class="mau-stepper__line" [class.mau-stepper__line--done]="showTerminationSelectFinalStateGenerate"></div>
        <div class="mau-stepper__step">
          <div class="mau-stepper__dot"
               [class.mau-stepper__dot--active]="filesTerminationGenerate.length > 0"
               [class.mau-stepper__dot--idle]="filesTerminationGenerate.length === 0">
            <span>3</span>
          </div>
          <span class="mau-stepper__label">Configurar</span>
        </div>
      </div>

      <div class="mau-info-card">
        <div class="mau-info-card__header">
          <mat-icon class="mau-info-card__icon">info_outline</mat-icon>
          <span class="mau-info-card__title">Instrucciones</span>
        </div>
        <ol class="mau-info-card__steps">
          <li>Descargue el archivo con el formato</li>
          <li>Diligencie los datos en el archivo descargado</li>
          <li>Cargue el archivo diligenciado</li>
        </ol>
        <div class="mau-info-card__note"><mat-icon>warning_amber</mat-icon>Máximo 499 registros por carga</div>
        <div class="mau-conditions-card">
          <div class="mau-conditions-card__title"><mat-icon>checklist</mat-icon>Condiciones para retiros masivos</div>
          <ul class="mau-conditions-card__list">
            <li>El contrato laboral debe tener fecha de inicio, salario y subsidio.</li>
            <li>El trabajador no debe tener otra solicitud en trámite.</li>
          </ul>
        </div>
      </div>

      <div class="mau-section">
        <div class="mau-section__label">Formato para descargar</div>
        <div class="mau-download-card">
          <div class="mau-download-card__info">
            <mat-icon class="mau-download-card__icon">description</mat-icon>
            <span class="mau-download-card__text">Plantilla de retiros masivos</span>
          </div>
          <a [href]="urlFormat" download class="mau-btn mau-btn--download"><mat-icon>file_download</mat-icon>Descargar</a>
        </div>
      </div>

      <div class="mau-section" *ngIf="showTerminationFormatLoadGenerate">
        <div class="mau-section__label">Cargar formato diligenciado</div>
        <ngx-dropzone *ngIf="filesTerminationGenerate.length === 0" (change)="onSelectTerminationGenerate($event)" class="mau-dropzone" [multiple]="false">
          <ngx-dropzone-label class="mau-dropzone__label">
            <mat-icon class="mau-dropzone__icon">cloud_upload</mat-icon>
            <span class="mau-dropzone__text">Clic aquí o arrastra y suelta el archivo</span>
            <span class="mau-dropzone__hint">XLSX, CSV, PDF</span>
          </ngx-dropzone-label>
        </ngx-dropzone>
        <div *ngIf="filesTerminationGenerate.length > 0" class="mau-file-chip">
          <mat-icon class="mau-file-chip__icon">insert_drive_file</mat-icon>
          <span class="mau-file-chip__name">{{ filesTerminationGenerate[0]?.name }}</span>
          <button mat-icon-button class="mau-file-chip__remove" (click)="removeFileTerminationGenerate()"><mat-icon>close</mat-icon></button>
        </div>
        <div class="mau-section" *ngIf="showTerminationSelectFinalStateGenerate">
          <div class="mau-section__label">Tipo de retiro</div>
          <div class="mau-select-wrap">
            <app-select-search-custom [_dataSource]="TypeOfWithdrawals" [dataShow]="'Name'" [dataValue]="'Id'"
                                      [siteCtrl]="controlSearchTypeOfWithdrawals" [inputType]="'text'"
                                      (onSelectionChange)="changeTerminationSelectGenerate($event)">
            </app-select-search-custom>
          </div>
        </div>
        <ng-container *ngIf="showEndAccess">
          <div class="mau-section__label">Fin de acceso</div>
          <form [formGroup]="formDate" class="mau-date-form">
            <div class="mau-date-row">
              <label class="mau-field-label mau-date-row__label">Fecha de fin de acceso</label>
              <mat-form-field class="mau-date-field" appearance="outline">
                <input matInput [matDatepicker]="picker2" formControlName="DateEndAccess"
                       [min]="today" readonly (keydown)="$event.preventDefault()"
                       (paste)="$event.preventDefault()" (click)="picker2.open()" placeholder="dd/mm/aaaa" />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="mau-date-hint">
              <mat-icon>info_outline</mat-icon>
              La fecha de fin de acceso se modificará al generar las liquidaciones.
            </div>
          </form>
        </ng-container>
        <div class="mau-comment-wrap">
          <label class="mau-field-label">Comentario</label>
          <mat-form-field class="mau-comment-field" appearance="outline">
            <textarea matInput [(ngModel)]="commentaryTerminationGenerate" maxlength="280" rows="3" placeholder="Escriba un comentario..."></textarea>
            <mat-hint align="end">{{ commentaryTerminationGenerate?.length || 0 }}/280</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <ng-container *ngIf="module !== 'GenerateWithdrawals'">
        <div class="mau-history-header"><mat-icon>history</mat-icon><span>Actualizaciones</span></div>
        <div class="mau-empty-state" *ngIf="documentos?.length === 0 && !data?.typeGestor">
          <mat-icon class="mau-empty-state__icon">folder_open</mat-icon>
          <span class="mau-empty-state__text">0 documentos guardados</span>
        </div>
        <div class="mau-updates-list">
          <ng-container *ngFor="let doc of documentos">
            <div class="mau-update-card" *ngIf="doc; else removedDoc">
              <div class="mau-update-card__row">
                <span class="mau-update-card__label">Actualizado</span>
                <span class="mau-update-card__value" [matTooltip]="getMassUploadHistoryDate(doc?.CreateDate)">{{ getMassUploadHistoryDate(doc?.CreateDate) || 'Fecha no reportada' }}</span>
                <mat-icon class="mau-update-card__user" matTooltipPosition="above" [matTooltip]="doc?.UserName || 'Usuario no reportado'">account_circle</mat-icon>
              </div>
              <div class="mau-update-card__row">
                <span class="mau-update-card__label">Documento</span>
                <span class="mau-update-card__filename" [matTooltip]="getInfoDocFileName(doc?.InfoDocJson)">{{ getInfoDocFileName(doc?.InfoDocJson) || 'Documento no reportado' }}</span>
                <button mat-icon-button class="mau-update-card__view-btn" *ngIf="getInfoDocFileUrl(doc?.InfoDocJson)"
                        matTooltip="Descargar documento" matTooltipPosition="above"
                        (click)="openInfoDocFile(doc?.InfoDocJson)" [disableRipple]="true">
                  <mat-icon>visibility</mat-icon>
                </button>
              </div>
              <div class="mau-update-card__row">
                <span class="mau-update-card__label">Estado</span>
                <span class="mau-status-badge"
                      [class.mau-status-badge--completed]="doc?.Status === 'COMPLETADO'"
                      [class.mau-status-badge--error]="doc?.Status === 'ERROR'"
                      [class.mau-status-badge--started]="doc?.Status === 'INICIADO'"
                      [matTooltip]="'Estado: ' + (doc?.Status || 'No reportado')">
                  <mat-icon *ngIf="doc?.Status === 'COMPLETADO'">check_circle</mat-icon>
                  <mat-icon *ngIf="doc?.Status === 'ERROR'">error_outline</mat-icon>
                  <mat-icon *ngIf="doc?.Status === 'INICIADO'">hourglass_top</mat-icon>
                  {{ doc?.Status || 'No reportado' }}
                </span>
              </div>
              <button class="mau-btn mau-btn--report" (click)="openDialogInforme(doc)">
                <mat-icon>bar_chart</mat-icon>Ver informe
              </button>
            </div>
            <ng-template #removedDoc>
              <div class="mau-update-card mau-update-card--removed">
                <mat-icon>remove_circle_outline</mat-icon>Documento removido
              </div>
            </ng-template>
          </ng-container>
        </div>
      </ng-container>
    </div>

  </div><!-- fin mau-content scrollable -->

  <!-- ══ FOOTER FIJO (título arriba, este abajo, scroll en el medio) ══ -->
  <div class="mau-footer" *ngIf="!data.typeGestor">
    <button class="mau-btn mau-btn--cancel" (click)="onNoClick()">
      {{ (data.typeOperator === 'show') ? 'Cerrar' : 'Cancelar' }}
    </button>
    <!-- Personal / Employer -->
    <button class="mau-btn mau-btn--save"
            *ngIf="(module === 'Personal' || module === 'Employer') && typeShowDialog === 1 && files.length !== 0 && exitPermissionCompany('massuploadpersonal.personalcreation')"
            (click)="submitInitDocument()">
      <mat-icon>play_arrow</mat-icon>Iniciar
    </button>
    <!-- Planillas -->
    <button class="mau-btn mau-btn--save"
            *ngIf="module === 'Planillas' && files.length !== 0"
            (click)="submitInitPlanillas()">
      <mat-icon>play_arrow</mat-icon>Iniciar
    </button>
    <!-- DOCREQ -->
    <button class="mau-btn mau-btn--save"
            *ngIf="typeShowDialog === 2 && filesLoadDocument.length !== 0 && exitPermissionCompany('massuploadpersonal.updaterequirement')"
            (click)="submitInitDocreq()">
      <mat-icon>save</mat-icon>Guardar
    </button>
    <!-- FechaReq -->
    <button class="mau-btn mau-btn--save"
            *ngIf="typeShowDialog === 3 && filesDateReq.length !== 0 && exitPermissionCompany('massuploadpersonal.updaterequirementdate')"
            (click)="submitInitFechreq()">
      <mat-icon>save</mat-icon>Guardar
    </button>
    <!-- Termination -->
    <button class="mau-btn mau-btn--save"
            *ngIf="module === 'Termination' && filesTermination.length !== 0 && showBtnSaveTermination === true"
            [disabled]="!exitPermissionCompany('massuploadtermination.changestate')"
            (click)="submitInitTermination()">
      <mat-icon>save</mat-icon>Guardar
    </button>
    <!-- GenerateWithdrawals -->
    <button class="mau-btn mau-btn--save"
            *ngIf="module === 'GenerateWithdrawals' && filesTerminationGenerate.length !== 0 && showBtnSaveTerminationGenerate === true"
            (click)="OnsubmitTerminationGenerateWithdrawals()">
      <mat-icon>save</mat-icon>Guardar
    </button>
  </div>

</div>
